import React from 'react';
import { useNavigate } from "react-router-dom";

function Error404() {

    const Navigate = useNavigate();

    return (
        <div className='UserProfileFull'>
            <div className='UserProfileInnerDiv'>
                <div className='ErrorPageCentering'>
                    <img alt='' className='ErrorPageBackgroundImage' src='https://static.yomecontrolo.cl/public/B2B/ErrorPageBackground.png'/>
                    <div className='ErrorPageSubtitle'>Página no encontrada</div>
                    <div className='ErrorPageTitle'>Error 404</div>
                    <div className='ErrorPageSubtitle'>Revisa que donde te dirigías aún se encuentra disponible o el enlace es incorrecto.</div>
                    <div className="GeneralPurpleButtonFlex ErrorPageButton" onClick={() => Navigate("/")}>
                        <div className="GeneralPurpleButtonText">Volver al Inicio</div>
                        <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Error404;